<template>
  <header class="hd">
    <div class="ui-container hd__wrap">
      <router-link to="/index.html" class="hd__logo" title="艾斯达 Asstar 首页">
        <img src="/images/pclogo.png" alt="艾斯达 Asstar" />
      </router-link>

      <nav class="hd__nav" aria-label="主导航">
        <router-link to="/index.html" class="hd-nav" :class="{ 'is-active': isActive('home') }">
          首页
        </router-link>

        <div class="hd-nav hd-nav--drop" :class="{ 'is-active': isActive('product') }">
          <span class="hd-nav__label">产品与服务<i class="hd-caret"></i></span>
          <div class="hd-drop">
            <div class="hd-drop__inner">
              <router-link to="/products.html" class="hd-drop__item">
                <span class="hd-drop__icon">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" /><rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
                    <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" /><rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
                  </svg>
                </span>
                <span class="hd-drop__text">
                  <b>全部产品</b>
                  <em>AI 伙伴 · 智能教育 · 智能家居 · 行业终端</em>
                </span>
              </router-link>
              <router-link to="/service/aiot.html" class="hd-drop__item">
                <span class="hd-drop__icon">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12.5a10 10 0 0114 0M8.5 16a5.5 5.5 0 017 0" /><circle cx="12" cy="19.5" r="1.2" fill="currentColor" stroke="none" />
                  </svg>
                </span>
                <span class="hd-drop__text">
                  <b>AIOT 服务</b>
                  <em>设备接入 · 物联网方案 · 硬件定制</em>
                </span>
              </router-link>
              <router-link to="/service/llm.html" class="hd-drop__item">
                <span class="hd-drop__icon">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" /><path d="M18.5 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" />
                  </svg>
                </span>
                <span class="hd-drop__text">
                  <b>大模型服务</b>
                  <em>私有化部署 · 知识库 · 智能体</em>
                </span>
              </router-link>
            </div>
          </div>
        </div>

        <router-link to="/solutions.html" class="hd-nav" :class="{ 'is-active': isActive('solutions') }">
          解决方案
        </router-link>

        <router-link to="/tech.html" class="hd-nav" :class="{ 'is-active': isActive('tech') }">
          技术与支持
        </router-link>

        <router-link to="/mall.html" class="hd-nav" :class="{ 'is-active': isActive('mall') }">
          星选商城
        </router-link>

        <router-link to="/about.html" class="hd-nav" :class="{ 'is-active': isActive('about') }">
          关于我们
        </router-link>
      </nav>

      <button
        class="hd__burger"
        :class="{ 'is-open': drawerOpen }"
        type="button"
        aria-label="打开导航"
        @click="drawerOpen = !drawerOpen"
      >
        <span></span><span></span><span></span>
      </button>
    </div>

    <div class="hd-mask" :class="{ 'is-open': drawerOpen }" @click="drawerOpen = false"></div>

    <div class="hd-drawer" :class="{ 'is-open': drawerOpen }">
      <div class="hd-drawer__inner">
        <router-link to="/index.html" class="hd-drawer__item" :class="{ 'is-active': isActive('home') }" @click.native="drawerOpen = false">首页</router-link>

        <div class="hd-drawer__group">
          <span class="hd-drawer__label">产品与服务</span>
          <router-link to="/products.html" class="hd-drawer__sub" :class="{ 'is-active': isActive('products') }" @click.native="drawerOpen = false">全部产品</router-link>
          <router-link to="/service/aiot.html" class="hd-drawer__sub" :class="{ 'is-active': isActive('aiot') }" @click.native="drawerOpen = false">AIOT 服务</router-link>
          <router-link to="/service/llm.html" class="hd-drawer__sub" :class="{ 'is-active': isActive('llm') }" @click.native="drawerOpen = false">大模型服务</router-link>
        </div>

        <router-link to="/solutions.html" class="hd-drawer__item" :class="{ 'is-active': isActive('solutions') }" @click.native="drawerOpen = false">解决方案</router-link>
        <router-link to="/tech.html" class="hd-drawer__item" :class="{ 'is-active': isActive('tech') }" @click.native="drawerOpen = false">技术与支持</router-link>
        <router-link to="/mall.html" class="hd-drawer__item" :class="{ 'is-active': isActive('mall') }" @click.native="drawerOpen = false">星选商城</router-link>
        <router-link to="/about.html" class="hd-drawer__item" :class="{ 'is-active': isActive('about') }" @click.native="drawerOpen = false">关于我们</router-link>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: "headerel",
    data() {
      return { drawerOpen: false };
    },
    watch: {
      $route() {
        this.drawerOpen = false;
      }
    },
    computed: {
      routeName() {
        return this.$route.name || "";
      }
    },
    methods: {
      isActive(group) {
        var name = this.routeName;
        switch (group) {
          case "home":
            return name === "home";
          case "product":
            return name === "products" || name === "aiot" || name === "llm";
          case "solutions":
            return name === "solutions";
          case "tech":
            return name === "tech";
          case "mall":
            return name === "mall";
          case "about":
            return name === "about" || name === "safe";
          default:
            return false;
        }
      }
    }
  };
</script>

<style scoped>
  .hd {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 72px;
    background: #ffffff;
    border-bottom: 1px solid #f0e9e8;
    box-shadow: 0 2px 12px rgba(31, 35, 45, 0.04);
  }

  .hd__wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
  }

  .hd__logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .hd__logo img {
    display: block;
    height: 60px;
    width: auto;
  }

  .hd__nav {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .hd-nav {
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 17px;
    font-size: 15px;
    color: #4c515b;
    cursor: pointer;
    transition: color 0.2s ease;
  }

  .hd-nav:hover { color: #e8382f; }

  .hd-nav.is-active {
    color: #e8382f;
    font-weight: 600;
  }

  /* 选中态下划线（官网同款） */
  .hd-nav.is-active::after,
  .hd-nav:hover::after {
    content: "";
  }

  .hd-nav__label {
    display: flex;
    align-items: center;
  }

  .hd-caret {
    display: inline-block;
    margin-left: 6px;
    border: 4px solid transparent;
    border-top-color: currentColor;
    transform: translateY(2px);
    transition: transform 0.2s ease;
  }

  .hd-nav--drop { position: relative; }

  .hd-drop {
    position: absolute;
    top: 100%;
    left: 50%;
    padding-top: 10px;
    opacity: 0;
    visibility: hidden;
    transform: translate(-50%, 6px);
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
  }

  .hd-nav--drop:hover .hd-drop {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, 0);
  }

  .hd-nav--drop:hover .hd-caret {
    transform: translateY(0) rotate(180deg);
  }

  .hd-drop__inner {
    width: 320px;
    padding: 10px;
    background: #fff;
    border: 1px solid #f0e9e8;
    border-radius: 16px;
    box-shadow: 0 24px 48px -16px rgba(196, 45, 30, 0.22);
  }

  .hd-drop__item {
    display: flex;
    align-items: flex-start;
    padding: 12px;
    border-radius: 12px;
    transition: background 0.18s ease;
  }

  .hd-drop__item:hover { background: #fdf3f2; }

  .hd-drop__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    margin-right: 12px;
    border-radius: 10px;
    background: #fdeceb;
    color: #e8382f;
    transition: background 0.18s ease, color 0.18s ease;
  }

  .hd-drop__item:hover .hd-drop__icon {
    background: #e8382f;
    color: #fff;
  }

  .hd-drop__text b {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #23262d;
  }

  .hd-drop__text em {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    font-style: normal;
    color: #8a909b;
  }

  /* ---------- 移动端汉堡与抽屉 ---------- */
  .hd__burger {
    display: none;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    border-radius: 10px;
    background: #fdf3f2;
    cursor: pointer;
  }
  .hd__burger span {
    display: block;
    width: 20px;
    height: 2px;
    margin: 0 auto;
    background: #23262d;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }
  .hd__burger.is-open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
  .hd__burger.is-open span:nth-child(2) { opacity: 0; }
  .hd__burger.is-open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

  .hd-mask {
    position: fixed;
    top: 72px;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(31, 35, 45, 0.42);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.22s ease, visibility 0.22s;
    z-index: 998;
  }
  .hd-mask.is-open { opacity: 1; visibility: visible; }

  .hd-drawer {
    position: fixed;
    top: 72px;
    right: 0;
    bottom: 0;
    width: 300px;
    max-width: 82vw;
    background: #fff;
    box-shadow: -12px 0 40px rgba(31, 35, 45, 0.14);
    transform: translateX(100%);
    transition: transform 0.26s ease;
    overflow-y: auto;
    z-index: 999;
  }
  .hd-drawer.is-open { transform: translateX(0); }
  .hd-drawer__inner { padding: 12px 16px 32px; }
  .hd-drawer__item {
    display: block;
    padding: 13px 12px;
    border-radius: 12px;
    font-size: 15px;
    color: #4c515b;
  }
  .hd-drawer__item.is-active {
    color: #e8382f;
    font-weight: 600;
    background: #fdf3f2;
  }
  .hd-drawer__group { margin-top: 4px; }
  .hd-drawer__label {
    display: block;
    padding: 13px 12px 6px;
    font-size: 13px;
    color: #8a909b;
  }
  .hd-drawer__sub {
    display: block;
    padding: 10px 12px 10px 24px;
    border-radius: 10px;
    font-size: 14px;
    color: #4c515b;
  }
  .hd-drawer__sub.is-active { color: #e8382f; background: #fdf3f2; }

  /* 断点：1023px 平板收起导航，767px 手机压缩头部高度 */
  @media (max-width: 1023px) {
    .hd__logo img { height: 48px; }
    .hd__nav { display: none; }
    .hd__burger { display: flex; }
  }

  @media (max-width: 767px) {
    .hd,
    .hd__wrap { height: 62px; }
    .hd-mask,
    .hd-drawer { top: 62px; }
    .hd__logo img { height: 42px; }
    .hd-drawer { width: 78vw; }
  }
</style>
